/**
 * NGXS actions for ReferenceDataState.
 *
 * Two user-visible flows: EnsureInitialized (seed on first launch) and
 * SyncIfStale (check the server's data_version and pull updates). Both
 * are idempotent; it's fine to dispatch them multiple times.
 */
export namespace ReferenceDataActions {
  export class EnsureInitialized {
    static readonly type = '[ReferenceData] Ensure Initialized';
  }

  export class SyncIfStale {
    static readonly type = '[ReferenceData] Sync If Stale';
  }

  export class SyncSuccess {
    static readonly type = '[ReferenceData] Sync Success';
    constructor(public refreshed: boolean) {}
  }

  export class SyncFailure {
    static readonly type = '[ReferenceData] Sync Failure';
    constructor(public error: string) {}
  }

  /**
   * Signals that the local seed load completed. After this fires,
   * pages that depend on reference data (Fish Limits) can render.
   */
  export class SeedLoaded {
    static readonly type = '[ReferenceData] Seed Loaded';
  }
}
